import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Icon } from "antd";
import Directions from "./../../../services/directions";
import { checkIfAlertOpened, showPath } from "./../../redux/actions";
import withTracker from "./../../withTracker";

class Path extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPathId: undefined,
      id: undefined,
      loading: true,
      data: undefined,
      distance: undefined,
      graves: undefined,
      showAlert: false,
      path: undefined,
      description: undefined,
    };
  }

  componentWillMount() {
    if (
      this.props &&
      !this.props.data.data.loading &&
      this.props.match.params
    ) {
      this.setState({
        loading: false,
        selectedPathId: parseInt(this.props.match.params.id),
      });
      this.props.data.data.paths.find((e) =>
        e.ID == this.props.match.params.id ? this.setState({ data: e }) : ""
      );
    }
  }

  componentDidMount() {
    if (this.props.data.data.paths && this.state.selectedPathId) {
      let path = this.props.data.data.paths.find(
        (e) => e.ID === this.state.selectedPathId
      );
      this.props.dispatch(showPath(path.mapPath, undefined));
      this.setState({ path: path.mapPath });
      let arr = [];
      path.graves.forEach((grave) => {
        let x = this.props.data.data.graves.find(
          (e) => parseInt(e.ID) === parseInt(grave)
        );
        arr.push(x);
      });
      this.setState({ graves: arr, description: path.Description });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(showPath(undefined, undefined));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.graves &&
      this.state.graves.length > 0 &&
      this.state.graves[0].geometry.closestLL &&
      !this.state.path
    ) {
      let arr = [];
      for (let grave in this.state.graves) {
        let exact = this.state.graves[grave].geometry.coordinates
          .map((e) => Number(e))
          .reverse();

        if (grave < this.state.graves.length - 1) {
          let path = Directions.findPath(
            this.state.graves[grave].geometry.closestLL,
            this.state.graves[parseInt(grave) + 1].geometry.closestLL
          );
          if (path) {
            path.path.unshift(exact);
            arr.push(...path.path);
          }
        } else if (Number(grave) === this.state.graves.length - 1) {
          arr.push(exact);
        }
      }
      this.props.dispatch(showPath(arr, undefined));
      this.setState({ path: arr });
    }
  }

  createMarkup = () => {
    return { __html: this.state.description };
  };

  parseToHtml() {
    return <div dangerouslySetInnerHTML={this.createMarkup()} />;
  }

  getGravesInPath() {
    return (
      <ul>
        {this.state.graves
          ? this.state.graves.map((e) => {
              return <li>{e.FirstName}</li>;
            })
          : ""}
      </ul>
    );
  }

  onShowPathToPath() {
    let start = this.props.data.entry;
    if (this.props.data.currentPosInBounds) {
      start = [this.props.data.er.lng, this.props.data.currentPosClosest.lat];
    }

    const path = Directions.findPathToPath(this.state.graves, start);

    if (path) {
      this.props.dispatch(showPath(this.state.path, path));
    }
  }

  render() {
    return (
      <div className="path">
        {this.state.showAlert === true &&
        !this.props.data.currentPosInBounds &&
        this.props.data.opened === false ? (
          <div className="alert-position">
            <div className="alert-text">
              <p>Aktualnie nie znajdujesz się na cmentarzu.</p>

              <p> Ścieżki będa wyznaczane od głównego wejścia.</p>

              <Button
                onClick={() => this.props.dispatch(checkIfAlertOpened(true))}
              >
                <Icon style={{ fontSize: 20 }} type="close" />
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="button-top">
          <Link className="close" to={`/${this.props.data.name}/paths`}>
            <Button>
              <Icon style={{ fontSize: 20 }} type="close" />
            </Button>
          </Link>

          <span>{this.state.data ? this.state.data.Name : ""}</span>
        </div>

        <main>
          <div className="path path-deskopt">
            <Button
              className="show-path-btn"
              disabled={this.state.graves && !this.state.graves.length > 0}
              onClick={() => this.onShowPathToPath()}
            >
              Wyznacz trasę
              <br />
              <span className="path-start-position">
                {this.props.data.currentPosInBounds
                  ? "od mojego położenia"
                  : "od wejścia"}
              </span>
            </Button>

            {this.state.setPath ? (
              <div></div>
            ) : (
              <div className="bordered">
                {this.state.description ? this.parseToHtml() : ""}
                <ul className="path-graves">
                  {this.state.graves
                    ? this.state.graves.map((e, id) => {
                        return (
                          <li key={id}>
                            <Link
                              to={`/${
                                this.props.data.name
                              }/grave/${this.props.data.data.graves.indexOf(
                                e
                              )}`}
                            >
                              {e.FirstName} {e.LastName}
                            </Link>
                          </li>
                        );
                      })
                    : ""}
                </ul>
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(Path)));



// WEBPACK FOOTER //
// ./src/js/containers/paths/single_path.js